export default {
  CHANGE_PASSWORD_POST_RECEIVE: "CHANGE_PASSWORD_POST_RECEIVE",
  CHANGE_PASSWORD_POST_ERROR: "CHANGE_PASSWORD_POST_ERROR",
  CHANGE_PASSWORD_POST_REQUEST: "CHANGE_PASSWORD_POST_REQUEST",
  INITIALIZED: "INITIALIZED",
  UNINITIALIZED: "UNINITIALIZED",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED"
};
